import { format } from "date-fns-tz";

const parseSafeDate = (date) => {
  if (!date) return null;

  if (date instanceof Date) {
    return isNaN(date.getTime()) ? null : date;
  }

  let _date;

  if (
    typeof date === "string" &&
    /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(date)
  ) {
    const [datePart, timePart] = date.split(" ");
    const [year, month, day] = datePart.split("-").map(Number);
    const [hour, minute] = timePart.split(":").map(Number);

    // React Native에서 안전한 Date 생성
    _date = new Date(year, month - 1, day, hour, minute);
  } else {
    _date = new Date(date);
  }

  return isNaN(_date.getTime()) ? null : _date;
};

export const formatDate = (
  date = new Date(),
  dateFormat = "yyyy-MM-dd",
  timeZone = "Asia/Seoul",
) => {
  const _date = parseSafeDate(date);
  if (!_date) return "";

  return format(_date, dateFormat, {
    timeZone,
  });
};
